// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionSummary" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionGroupResultGenShape } from "./chat-regression-group-result.gen";
import { ChatRegressionShortlistRecallGenShape } from "./chat-regression-shortlist-recall.gen";
import { ChatRegressionJudgeAgreementGenShape } from "./chat-regression-judge-agreement.gen";
import { ChatRegressionClarifierMetricsGenShape } from "./chat-regression-clarifier-metrics.gen";

export const ChatRegressionSummaryGenShape = z.strictObject({
  groups: z.array(ChatRegressionGroupResultGenShape),
  caseCount: z.number(),
  passCount: z.number(),
  passed: z.boolean(),
  costUsd: z.number(),
  shortlistRecall: ChatRegressionShortlistRecallGenShape,
  judgeAgreement: ChatRegressionJudgeAgreementGenShape,
  clarifierMetrics: ChatRegressionClarifierMetricsGenShape,
});
